import { Coins, ShieldCheck, Leaf, Clock, Users, Route } from "lucide-react";
const benefits = [{
  id: 1,
  title: "Drastiskt sänkta kostnader",
  description: "Utan behov av en mänsklig förare minskar driftskostnaderna avsevärt, vilket gör autonoma resor betydligt billigare än att äga en egen bil.",
  icon: "coins"
}, {
  id: 2,
  title: "Överlägsen trafiksäkerhet",
  description: "Robotaxis blir aldrig trötta, distraherade eller påverkade. Avancerade sensorer och AI reagerar snabbare än mänskliga reflexer för att förhindra olyckor.",
  icon: "shield"
}, {
  id: 3,
  title: "Nollutsläpp och grönare städer",
  description: "Helt elektriska flottor minskar koldioxidutsläppen dramatiskt och bidrar till renare luft och tystare stadsmiljöer.",
  icon: "leaf"
}, {
  id: 4,
  title: "Återvunnen tid",
  description: "Förvandla pendlingstiden till produktiv arbetstid eller avkoppling. Bilen kör, du bestämmer vad du vill göra med din tid.",
  icon: "clock"
}, {
  id: 5,
  title: "Mobilitet för alla",
  description: "Ger oberoende och frihet till äldre, personer med funktionsnedsättning och de som saknar körkort genom tillgänglig transport dygnet runt.",
  icon: "users"
}, {
  id: 6,
  title: "Optimerat trafikflöde",
  description: "Uppkopplade fordon kommunicerar med varandra och infrastrukturen för att minska köer, optimera rutter och effektivisera hela transportsystemet.",
  icon: "route"
}];
export default function WhyRobotaxiChangesEverything() {
  const renderIcon = (iconName: string) => {
    const props = {
      className: "w-12 h-12 text-primary",
      strokeWidth: 1.5
    };
    switch (iconName) {
      case "coins":
        return <Coins {...props} />;
      case "shield":
        return <ShieldCheck {...props} />;
      case "leaf":
        return <Leaf {...props} />;
      case "clock":
        return <Clock {...props} />;
      case "users":
        return <Users {...props} />;
      case "route":
        return <Route {...props} />;
      default:
        return <Route {...props} />;
    }
  };
  return <section id="varför-robotaxi-förändrar-allt" className="dark bg-background text-foreground py-24 px-6 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-16">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-foreground mb-6">
            Varför Robotaxi förändrar allt
          </h2>
          <p className="font-sans text-lg text-muted-foreground leading-relaxed">
            Övergången till autonoma fordon är inte bara en teknisk uppgradering, det är ett paradigmskifte. Genom att kombinera artificiell intelligens med elektrifiering skapar vi ett transportsystem som är säkrare, billigare och mer hållbart.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {benefits.map((benefit, i) => <div key={benefit.id} data-index={i} className="flex flex-col items-start">
              <div className="mb-6 p-4 rounded-2xl bg-secondary/50 border border-border/50">
                {renderIcon(benefit.icon)}
              </div>
              <h3 className="font-serif text-xl font-bold text-foreground mb-3">
                {benefit.title}
              </h3>
              <p className="font-sans text-base text-muted-foreground leading-relaxed">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}